import { AbstractControl, ValidationErrors } from "@angular/forms";

export function containsURL(control: AbstractControl): ValidationErrors | null{
    const urlRegex = /[:\/]|www\./;
    if(urlRegex.test(control.value?.toLowerCase())){
      return { invalidFormat: true, message: 'urlRestricted' }
    }
    return null;
  }